import Placeholder from "../images/placeholder.png";
import WordstoDescribe from "../images/publications/words-to-describe-what-im-feeling.png";
import PeerSupportMisalignments from "../images/publications/is-this-really.png";
import LLMDisinformation from "../images/publications/sword-and-shield.png";

export const phdResearchProjects = [
  {
    id: "waves",
    title: "WAVES",
    role: "Project Lead",
    duration: "Jan 2026 - Present",
    summary: "Exploring multimodal LLMs' capabilities in supporting self-expression in reflective and emotional contexts.",
    contributions: [
      "Mentored undergraduate student working on system development",
      "Scoped and designed a user study",
      "Prepared Institutional Review Board application materials",
      "Analysed findings and prepared manuscript"
    ],
    pillarIds: [
      "reflection",
      "agency"
    ],
    menteeIds: [
      "shuenn-yuen"
    ],
    collaboratorIds: [],
    shown: true,
    associations: {},
    img: Placeholder
  },
  {
    id: "on-device-slm-mental-health",
    title: "On-Device Small Language Models for Mental Health",
    role: "Contributing Researcher",
    duration: "Sep 2025 - Present",
    summary: "Exploring how on-device small language models are deployed and evaluated in mental health settings",
    contributions: [
      "Contributing to a review and analysis of past work"
    ],
    pillarIds: [
      "misalignment"
    ],
    collaboratorIds: [],
    menteeIds: [],
    shown: false,
    img: Placeholder
  },
  {
    id: "llms-pfa",
    title: "LLMs for Psychological First Aid (PFA)",
    role: "Contributing Researcher",
    duration: "Jul 2025 - Present",
    summary: "Exploring whether Large Language Models (LLMs) can provide PFA in distress contexts",
    contributions: [
      "Assisted in scoping the user study design",
      "Prepared Institutional Review Board application materials",
      "Supporting methodological development and evaluation of LLM effectiveness in high-stakes scenarios"
    ],
    pillarIds: [
      "misalignment"
    ],
    collaboratorIds: [],
    menteeIds: [],
    shown: false,
    img: Placeholder
  },
  {
    id: "meralion-crisis-care",
    title: "MERaLiON for Crisis Care",
    role: "Contributing Researcher",
    duration: "Jul 2025 - Present",
    summary: "Evaluating how LLMs perform in crisis care and suicide risk detection, with a focus on local linguistic context and benchmarking.",
    contributions: [
      "Conceived and scoped the user study design and research direction",
      "Contributed to project framing and guided team discussions on methodology",
      "Supported planning for adapting evaluation strategies to Singapore-based datasets and models"
    ],
    pillarIds: [
      "misalignment"
    ],
    collaboratorIds: [],
    menteeIds: [],
    shown: false,
    img: Placeholder
  },
  {
    id: "trust",
    title: "TRUST",
    role: "Project Lead",
    duration: "May 2025 - Mar 2026",
    summary: "Explored the role of explicit explainability in AI reasoning models within mental health support contexts",
    contributions: [
      "Designing experimental protocols to evaluate how different AI reasoning styles (e.g., step-by-step vs. intuitive) influence trust, perceived helpfulness, and interpretability",
      "Guided undergraduate students in brainstorming, study design, and early-stage preparation",
      "Supported the scoping of the user study and defining of the research framework",
      "Prepared comparative analysis to examine alignment between human (expert and peer supporter) and LLM evaluations of reasoning quality"
    ],
    pillarIds: [
      "reflection",
      "misalignment",
      "agency"
    ],
    menteeIds: [
      "arishya-jindal",
      "skylar-looi"
    ],
    collaboratorIds: [],
    shown: true,
    img: Placeholder
  },
  {
    id: "acpchat",
    title: "ACPChat",
    role: "Project Lead",
    duration: "Mar 2025 - Jun 2026",
    summary: "Examining how people train and evaluate AI agents that can act as bounded advocates for high-subjectivity advance care planning (ACP) decisions, including post-capacity contexts where participation, authorisation, and agency become uncertain, with attention to provenance, temporality, and legitimacy.",
    contributions: [
      "Scoped and designed a co-design user study across 4 workshops with 15 participants",
      "Prepared and submitted IRB application",
      "Conducted workshops exploring how people would train and evaluate an AI agent acting on their behalf in hypothetical ACP scenarios",
      "Analysed findings on advocate vs tool/proxy framings and authored papers reporting key insights",
      "Led a team of facilitators in study facilitation and analysis"
    ],
    publications: [
      {
        title: "Words to Describe What I'm Feeling: Exploring the Potential of AI Agents for High Subjectivity Decisions in Advance Care Planning",
        label: "CHI26 Paper"
      },
      {
        title: "Acts of Configuration: Rethinking Provenance, Temporality and Legitimacy in Post-Mortem Agents",
        label: "DIS26 PWiP"
      },
      {
        title: "Redistributing Voice and Responsibility: AI in Relationship-Centred Care",
        label: "CHI26 Workshop"
      }
    ],
    pillarIds: [
      "reflection",
      "agency"
    ],
    collaboratorIds: [
      "darryl-lim",
      "john-henry-lim",
      "melanie-quek",
      "pin-sym-foong",
      "swarangi-mehta",
      "chenyu-zhao"
    ],
    menteeIds: [],
    associations: {
      publications: [
        "Words to Describe What I'm Feeling: Exploring the Potential of AI Agents for High Subjectivity Decisions in Advance Care Planning",
        "Acts of Configuration: Rethinking Provenance, Temporality and Legitimacy in Post-Mortem Agents",
        "Redistributing Voice and Responsibility: AI in Relationship-Centred Care"
      ],
      news: [
        "🇸🇬 Attended DIS 2026 in Singapore! Presented 2 PWiP papers and served as a Student Volunteer.",
        "🇪🇸 Attended CHI 2026 in Barcelona, Spain! Presented a full paper and a workshop paper, took part in a workshop and attended a meet-up.",
        "📣 Two first-author PWiP papers accepted at DIS 2026.",
        "🏅 Our CHI 2026 full paper received an Honourable Mention Award.",
        "📣 First-author workshop paper accepted at CHI 2026.",
        "📣 First-author full paper accepted at CHI 2026."
      ],
      features: [
        "ACPChat research (CHI26 paper) featured on <a href=\"https://scienmag.com/new-tech-enables-communication-for-nonverbal-patients/\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">ScienMag</a>, <a href=\"https://bioengineer.org/new-tech-enables-communication-for-nonverbal-patients/\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">Bioengineer.org</a>, and <a href=\"https://techxplore.com/news/2026-07-ai-agent-machines-patients-life.html\" target=\"_blank\" rel=\"noopener noreferrer\" class=\"text-green dark:text-green-dark underline underline-offset-2\">TechXplore</a>."
      ]
    },
    shown: true,
    img: WordstoDescribe
  },
  {
    id: "sense",
    title: "SENSE",
    role: "Project Lead (Jan 2025 - Aug 2025), Contributing Researcher (Aug 2025 - Present)",
    duration: "Jan 2025 - Present",
    summary: "Developing a mobile application to capture text communication, emotions, and keystroke dynamics, with planned integration of wearable sensing and LLM-supported prompts",
    contributions: [
      "Mentored undergraduate students and research officer working on app development and data collection",
      "Contributed to scoping research direction and study design",
      "Supported prototyping and planning for multimodal emotion tracking in real-world settings"
    ],
    pillarIds: [
      "misalignment"
    ],
    menteeIds: [
      "vadora-tang",
      "hugo-chen"
    ],
    collaboratorIds: [
      "quoc-nam-nguyen"
    ],
    shown: true,
    img: Placeholder
  },
  {
    id: "forge",
    title: "FORGE",
    role: "Project Lead",
    duration: "Jan 2025 - Present",
    summary: "Creating and publishing an independent dataset of mental health conversations from a local online forum",
    contributions: [
      "Supervised undergraduate students on data collection, cleaning, and organisation of the dataset",
      "Contributed to scoping dataset design and ethical considerations",
      "Advised on analysis and preparation for comparison against existing mental health datasets"
    ],
    pillarIds: [
      "misalignment"
    ],
    menteeIds: [
      "edward-chan",
      "kaviraam",
      "manya-mehra"
    ],
    collaboratorIds: [],
    shown: true,
    img: Placeholder
  },
  {
    id: "heartalk",
    title: "HearTalk",
    role: "Project Lead",
    duration: "Sep 2024 - May 2025",
    summary: "Creating a dataset of mental health-related posts from social media platforms with expert annotations",
    contributions: [
      "Supervised an undergraduate student in data collection and preprocessing",
      "Consolidated posts and comments from Reddit forums (e.g., r/SuicideWatch, r/depression, r/Anxiety)",
      "Provided oversight on dataset design and ethical considerations",
      "Advised on reproducible pipeline development for text data extraction"
    ],
    pillarIds: [
      "misalignment"
    ],
    menteeIds: [
      "owen-sengdalavong"
    ],
    collaboratorIds: [],
    shown: false,
    img: Placeholder
  },
  {
    id: "empathai",
    title: "EmpathAI",
    role: "Project Lead",
    duration: "Jun 2024 - Oct 2026",
    summary: "Investigating how AI-simulated clients, LLM-generated suggestions, and emotional-state visualisations can support peer supporters in Singapore, and how AI redistributes labour, risk, and responsibility when the boundaries of peer support remain unevenly defined.",
    contributions: [
      "Designed and conducted user studies with peer supporters and mental health professionals in Singapore",
      "Analysed how lived experience and organisational ambiguity shape peer support roles, emotional labour, and escalation judgement",
      "Examined misalignments between peer supporters and experts in LLM-supported interactions",
      "Developed design implications for AI that scaffolds relational care without supplanting it, with attention to cultural responsiveness and accountability"
    ],
    publications: [
      {
        title: "\"I Said Things I Needed to Hear Myself\": Peer Support as an Emotional, Organisational, and Sociotechnical Practice in Singapore",
        label: "arXiv preprint"
      },
      {
        title: "\"Is This Really a Human Peer Supporter?\": Misalignments Between Peer Supporters and Experts in LLM-Supported Interactions",
        label: "CSCW26 Paper"
      },
      {
        title: "I'm Not Able to Be There for You: Emotional Labour, Responsibility, and AI in Peer Support",
        label: "DIS26 PWiP"
      },
      {
        title: "Redistributing Voice and Responsibility: AI in Relationship-Centred Care",
        label: "CHI26 Workshop"
      }
    ],
    pillarIds: [
      "reflection",
      "misalignment"
    ],
    collaboratorIds: [],
    menteeIds: [
      "hugo-chen"
    ],
    associations: {
      news: [
        "🇺🇸 Attending CSCW 2026 in Salt Lake City, Utah, USA! Presenting 2 full papers and serving as a Student Volunteer.",
        "🇸🇬 Attended SG HCI Meetup 2026 in Singapore! Gave an oral presentation on my peer support research (DIS26 PWiP and CSCW26 full paper).",
        "🇸🇬 Attended DIS 2026 in Singapore! Presented 2 PWiP papers and served as a Student Volunteer.",
        "🇪🇸 Attended CHI 2026 in Barcelona, Spain! Presented a full paper and a workshop paper, took part in a workshop and attended a meet-up.",
        "📣 First-author full paper accepted at CSCW 2026.",
        "📣 Two first-author PWiP papers accepted at DIS 2026.",
        "📣 First-author workshop paper accepted at CHI 2026."
      ],
      publications: [
        "\"Is This Really a Human Peer Supporter?\": Misalignments Between Peer Supporters and Experts in LLM-Supported Interactions",
        "\"I'm Not Able to Be There for You\": Emotional Labour, Responsibility, and AI in Peer Support",
        "\"I Said Things I Needed to Hear Myself\": Peer Support as an Emotional, Organisational, and Sociotechnical Practice in Singapore",
        "Redistributing Voice and Responsibility: AI in Relationship-Centred Care",
        "Envisioning an AI-Enhanced Mental Health Ecosystem"
      ]
    },
    shown: true,
    img: PeerSupportMisalignments
  },
  {
    id: "blossom",
    title: "BLOSSOM",
    role: "Contributing Researcher",
    duration: "Sep 2023 - Present",
    summary: "Evaluation framework for LLMs in peer support and mental health contexts",
    contributions: [
      "Advised on framing and interpretation of findings for BLOSSOM, a behaviourally anchored benchmark grounded in therapeutic literature (CBT, MI, Active Listening) and applied to peer support conversations with multiple LLMs",
      "Provided feedback and input where possible"
    ],
    pillarIds: [
      "misalignment"
    ],
    collaboratorIds: [
      "charlotte-ng"
    ],
    menteeIds: [],
    shown: false,
    img: Placeholder
  },
  {
    id: "truthguardian",
    title: "TruthGuardian",
    role: "Contributing Researcher",
    duration: "Aug 2023 - Oct 2026",
    summary: "Exploring the impact of LLMs on disinformation dynamics through role-based communication games.",
    contributions: [
      "Assisted in designing and conducting user studies where participants, equipped with LLMs, enacted the roles of Disinformer, Moderator, and User",
      "Contributed to data analysis, focusing on how LLM use varied by role and influenced trust, persuasion, and group reasoning"
    ],
    publications: [
      {
        title: "Communication Games to Study Emerging Disinformation Scenarios With LLMs",
        label: "CSCW25 Poster"
      },
      {
        title: "Sword and Shield: Uses and Strategies of LLMs in Navigating Disinformation",
        label: "CSCW26 Paper"
      }
    ],
    pillarIds: [
      "agency"
    ],
    collaboratorIds: [
      "gionnieve-lim",
      "bryan-tan",
      "weiyan-shi",
      "ming-hui-chew",
      "ming-shan-hee"
    ],
    menteeIds: [],
    associations: {
      publications: [
        "Communication Games to Study Emerging Disinformation Scenarios With LLMs",
        "Sword and Shield: Uses and Strategies of LLMs in Navigating Disinformation"
      ],
      news: [
        "🇺🇸 Attending CSCW 2026 in Salt Lake City, Utah, USA! Presenting 2 full papers and serving as a Student Volunteer.",
        "📣 Third-author full paper accepted at CSCW 2026.",
        "🇳🇴 Attended CSCW 2025 in Bergen, Norway! Presented a poster.",
        "📣 Third-author poster paper accepted at CSCW 2025."
      ]
    },
    shown: true,
    img: LLMDisinformation
  }
];
